import algoliasearch, {SearchClient} from 'algoliasearch';

export const algoliaIndex = process.env.REACT_APP_ALGOLIA_INDEX_NAME!;
export function initAlgoliaClient(appId: string, apiKey: string): SearchClient {
    return algoliasearch(appId, apiKey);
}